import __request__ from "routing/request";
export function override(nodeId, status, requestOptions) {
  return __request__("PUT", `/cluster/${nodeId}/lbstatus/override/${status}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
